export default ['phone_number', 'save_pay'];
